import styled, { keyframes, css } from 'styled-components';

const moveParticles = () => {
    let styles = ``;

    for (let i = 0; i <= 30; i++) {
        styles += `
            @keyframes particle-animation-${i} {
                100% {
                    transform: translate3d(calc(${Math.random() * 90} * 1vw), calc(${Math.random() * 90} * 1vh), calc(${Math.random() * 100} * 1px));
                }
            }

            .particle:nth-child(${i}){
                animation: particle-animation-${i} 60s infinite;
                opacity: calc(${Math.random() * 90}/100);
                height: 10px;
                width: 10px;
                animation-delay: -${i} * .2s;
                transform: translate3d(calc(${Math.random() * 100} * 1vw), calc(${Math.random() * 100} * 1vh), calc(${Math.random() * 300} * 1px));
                background: hsl(${Math.random() * 360}, 59.7%, 71.8%);
            }

            .particle:nth-child(2n+3) {
                background: hsl(188%, 80%, 50%);
            }
        `
    }

    return css`${styles}`;
}

const float = keyframes`
    0% {
        top: 38%;
        opacity: 0;
    }

    20% {
        transform: rotate(5deg);
        opacity: 1;
    }

    40% {
        transform: rotate(-5deg);
    }

    60% {
        transform: rotate(5deg);
    }

    80% {
        transform: rotate(-5deg);
    }

    95% {
        opacity: 1;
    }

    100% {
        top: 0;
        opacity: 0;
    }
`;

export const NotFoundWrapper = styled.div`
    height: 100vh;
    position: relative;
    background: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: -8em;

    #particle-container {
        z-index: 0;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0);
    }
    
    .particle {
        position: absolute;
        border-radius: 50%;
    }

    ${moveParticles()}
`;

export const ErrorCode = styled.div`
    font-size: 120px;
    font-weight: 900;
    color: var(--primary);

    span {
        display: inline-block;

        &:not(:last-child) {
            margin-right: 9rem;
        }
    }
`;

export const ErrorMessage = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;

    span {
        color: var(--eyebrow-color);
        text-transform: uppercase;
        font-size: 1.6rem;
        font-weight: 400;
        letter-spacing: .5px;
        margin-bottom: 3rem;
    }

    .btn-continue {
        border: none;
        background-color: var(--primary);
        border-radius: 4px;
        color: var(--white);
        font-size: 18px;
        font-weight: 600;
        padding: 16px 32px;
        text-align: center;
        transition: all .3s ease;
        cursor: pointer;
        display: flex; 
        align-items: center;

        svg {
            width: 16px;
            height: 16px;
            margin-right: 16px;
        }


        &:hover {
            background-color: var(--primary-on-hover);
        }
    }
`;

export const Baloon = styled.div`
    height: 125px;
    width: 105px;
    background-color: rgba(80, 98, 205, .6);
    border: 1px solid var(--primary);
    border-radius: 75% 75% 70% 70%;
    position: fixed;
    left: 50%;
    top: 38%;
    margin-left: -3%;
    animation: ${float} 8s linear infinite;

    &::before {
        content: "";
        height: 75px;
        width: 1px;
        padding: 1px;
        background-color: #FDFD96;
        display: block;
        position: absolute;
        top: 125px;
        left: 0;
        right: 0;
        margin: auto;
    }

    &::after {
        content: "▲";
        text-align: center;
        display: block;
        position: absolute;
        color: inherit;
        top: 116px;
        left: 0;
        right: 0;
        margin: auto;
        font-size: 2rem;
    }

`;